/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/class-name-casing */
import { makeAutoObservable, configure } from 'mobx';
import request from './utils/request';
import MaskPopup from './components/Mask';
import { Toast } from 'antd-mobile';
import { platform, jumpHandle, handleLink } from './utils/Config';
import { isWeiBo, isWeiXinAndQQ, isWeiXin } from './utils/utils';
import { Link } from 'preact-router/match';
import trim from 'lodash/trim';
import UM from './utils/UM';
import { toPairsIn } from 'lodash';
configure({
  enforceActions: 'never',
});
class store {
  constructor() {
    makeAutoObservable(this);
  }
  keywords = '';
  oldKeywords = '';
  searchFlag = false;
  //搜索关键词
  searchInputTextChange = async (e: any) => {
    const text = trim(e.target.value);
    this.keywords = text;
    if (!text || text.length === 0) {
      this.keywords = '';
    }
  };
  //是否固定头部
  TabsTwoFixTop = false;
  TabsThreeFixTop = false;
  //查询主播列表
  HostCategoryList: any = [];
  HostCategoryListLoading = false;
  categoryId = 'all';
  postHostCategoryList = async () => {
    if (this.HostCategoryListLoading) return;
    this.HostCategoryListLoading = true;
    const { data, err }: any = await request(`/d11admin/goods/live/category`, {
      method: 'GET',
      data: {},
    });
    if (err) {
      if (`${err}` != 'Cancel') {
        this.HostCategoryListLoading = false;
      }
      return;
    }
    this.HostCategoryListLoading = false;
    this.HostCategoryList = data.data;
    // this.categoryId=data.data[0]?.categoryId;
  };
  //查询直播场次
  ByHostAllList: any = []; //前端手动分页
  ByHostList: any = [];
  ByHostListLoading = false;
  postByHostList = async (params: any) => {
    if (this.ByHostListLoading) return;
    this.ByHostListLoading = true;
    const { data, err }: any = await request(`/live/queryByHost`, {
      method: 'POST',
      data: params,
    });
    if (err) {
      if (`${err}` != 'Cancel') {
        this.ByHostListLoading = false;
      }
      return;
    }
    this.ByHostListLoading = false;
    this.ByHostAllList = data.data;
    if (data.data.length > 3) {
      this.ByHostList = data.data.slice(0, 3);
    } else {
      this.ByHostList = data.data;
    }
  };
  //查询商品分类列表
  ProductCategoryList: any = [];
  ProductCategoryListLoading = false;
  PostProductCategoryList = async (params: any) => {
    if (this.ProductCategoryListLoading) return;
    this.ProductCategoryListLoading = true;
    const { data, err }: any = await request(
      `/live/querySameProductCategoryList`,
      {
        method: 'POST',
        data: params,
      },
    );
    if (err) {
      if (`${err}` != 'Cancel') {
        this.ProductCategoryListLoading = false;
      }
      return;
    }
    this.ProductCategoryListLoading = false;
    this.ProductCategoryList = data.data;
  };

  //查询关联商品列表
  pageNum = 1;
  SameProductListTotal = 0;
  SameProductList: any = [];
  SameProductListLoading = false;
  SameProductListHasMore = true;
  postSameProductList = async (flag = false) => {
    if (this.SameProductListLoading) return;
    if (!this.SameProductListHasMore && flag == false) return;
    // this.SameProductListTotal=0;
    const SearchData = new URLSearchParams(window.location.search);
    let params: any = {
      pageSize: 30,
      pageNum: this.pageNum,
      ghId: SearchData.get('gh_id'),
    };
    if (this.categoryId == 'all' || flag) {
    } else {
      params.categoryId = this.categoryId;
    }
    if (flag) {
      if (this.keywords && this.keywords.length > 0) {
        this.pageNum = 1;
        params.pageNum = 1;
        params.text = this.keywords;
        UM({
          page: '首页',
          label: '点击搜索',
          event: '点击搜索',
          value: this.keywords,
        });
      } else {
        Toast.show({ content: '请输入搜索商品名称！' });
        return false;
      }
    }
    const liveFlag =
      !SearchData.has('gh_id') || SearchData.get('gh_id') == '3142205857';
    this.SameProductListLoading = true;
    const { data, err }: any = await request(
      liveFlag ? `/d11admin/goods/live/page` : `/d11admin/goods/live/page/new`,
      {
        method: 'POST',
        data: params,
      },
    );
    if (err) {
      if (`${err}` != 'Cancel') {
        this.SameProductListLoading = false;
        this.SameProductListHasMore = false;
      }
      return;
    }
    if (liveFlag) {
      this.SameProductListTotal = data.data.total;
    }
    const list = data.data.list || [];
    this.SameProductListLoading = false;
    if (list.length != params.pageSize) {
      this.SameProductListHasMore = false;
    }
    if (flag && list.length == 0) {
      Toast.show({ content: '不好意思亲，没有搜到呢，要不换个词再试一下！' });
      return false;
    } else if (flag) {
      this.oldKeywords = this.keywords;
      this.searchFlag = true;
    }
    if (this.pageNum == 1) {
      this.SameProductList = list;
    } else {
      this.SameProductList = [...this.SameProductList, ...list];
    }
    this.pageNum = this.pageNum + 1;
  };

  //查询直播间详情
  LiveDetailFlag = false;
  LiveDetail: any = {};
  LiveDetailLoading = false;
  PostLiveDetail = async (params: any) => {
    if (this.LiveDetailLoading) return;
    this.LiveDetailLoading = true;
    const { data, err }: any = await request(`/live/detail`, {
      method: 'POST',
      data: params,
    });
    this.LiveDetailLoading = false;
    if (err) return;
    this.LiveDetail = data.data;
  };

  //商品详情页
  homeFlag = false;
  homeFilter = null;
  goodsDetail: any = null;
  goodsDetailLoading = false;
  PostLiveDetailProduct = async (params: any) => {
    if (this.goodsDetailLoading) return;
    this.goodsDetailLoading = true;
    const { data, err }: any = await request(`/live/detailProduct`, {
      method: 'POST',
      data: params,
    });
    this.goodsDetailLoading = false;
    if (err) return;
    this.goodsDetail = data.data;
  };

  //博主合集
  ghId = null;
  ghInfo = {};
  //获取博主信息
  PostProductGetWeiBoInfo = async () => {
    const { data, err }: any = await request(
      `/product/getWeiBoInfo?ghId=${this.ghId}`,
      {
        method: 'POST',
        data: {
          ghId: this.ghId,
        },
      },
    );
    if (err) return;
    this.ghInfo = data.data;
  };
  //获取博主合集
  WeiBoCollectionList: any = [];
  WeiBoCollectionLoading = false;
  WeiBoCollectionListHasMore = true;
  WeiBoCollectionQueryCollect = async (params: any) => {
    if (!this.WeiBoCollectionListHasMore) return;
    if (this.WeiBoCollectionLoading) return;
    this.WeiBoCollectionLoading = true;
    let nowurl = `/weiBoCollection/queryCollect?index=${this.WeiBoCollectionList.length}`;
    if (params.date) {
      nowurl = `${nowurl}&date=${params.date}`;
    }
    const { data, err }: any = await request(nowurl, {
      method: 'GET',
      data: {
        ghId: this.ghId,
      },
    });
    if (err) {
      if (`${err}` != 'Cancel') {
        this.WeiBoCollectionLoading = false;
        this.WeiBoCollectionListHasMore = false;
      }
      return;
    }
    this.WeiBoCollectionLoading = false;
    if (data.data.length == 0) {
      this.WeiBoCollectionListHasMore = false;
      return false;
    }
    if (this.WeiBoCollectionList.length != 0) {
      this.WeiBoCollectionList = [...this.WeiBoCollectionList, ...data.data];
    } else {
      this.WeiBoCollectionList = data.data;
    }
  };
  //获取探店合集
  small = null;
  StoreProductList: any = [];
  StoreProductLoading = false;
  StoreProductListHasMore = true;
  StoreProduct = async () => {
    if (!this.StoreProductListHasMore) return;
    if (this.StoreProductLoading) return;
    this.StoreProductLoading = true;
    const { data, err }: any = await request(
      `/weiBoCollection/queryStoreProduct?index=${this.StoreProductList.length}`,
      {
        method: 'GET',
        data: {
          ghId: this.ghId,
        },
      },
    );
    if (err) {
      if (`${err}` != 'Cancel') {
        this.StoreProductLoading = false;
        this.StoreProductListHasMore = false;
      }
      return;
    }
    this.StoreProductLoading = false;
    if (data.data.length == 0) {
      this.StoreProductListHasMore = false;
      return false;
    }
    if (this.StoreProductList.length != 0) {
      this.StoreProductList = [...this.StoreProductList, ...data.data];
    } else {
      this.StoreProductList = data.data;
    }
  };
  handleWxWeapp = async () => {
    try {
      if (isWeiXin()) {
        const { data, err }: any = await request(
          `/api/repost/jsapi-config?url=${encodeURIComponent(
            window.location.href,
          )}`,
          {
            method: 'GET',
            data: {},
          },
          4,
        );
        if (err) {
          return;
        }
        if (data.result === 'success') {
          // eslint-disable-next-line no-undef
          wx.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId: data.data.appId, // 必填，公众号的唯一标识
            signature: data.data.signature,
            timestamp: data.data.timestamp,
            nonceStr: data.data.nonceStr,
            jsApiList: ['chooseImage', 'previewImage', 'closeWindow'], // 必填，需要使用的 JS 接口列表
            openTagList: ['wx-open-launch-weapp'], // 必填，需要使用的 JS 接口列表
          });
          wx.error(function (res) {
            console.log(res);
          });
        }
      }
    } catch {}
  };
  //初始化微信分享
  handleWxShare = async () => {
    try {
      if (isWeiXin()) {
        const { data, err }: any = await request(
          `/weixin/mywebchat/sign`,
          {
            method: 'POST',
            data: {
              url: window.location.href,
            },
          },
          2,
        );
        if (err) {
          return;
        }
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: data.data.appId, // 必填，公众号的唯一标识
          signature: data.data.signature,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的 JS 接口列表
        });
        // wx.config({
        //   debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        //   appId: "wx86caea8ec00ae84e", // 必填，公众号的唯一标识
        //   signature: "731cc1fbb4583e46ec7429fb29b1584b39d639b5",
        //   timestamp: "1665299362",
        //   nonceStr: "889675ba-06e4-457a-a1c9-32f9bdb5df2d",
        //   jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的 JS 接口列表
        // });
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '直播预告推送', // 分享标题
            desc: '李佳琦今日提前加购品，提前加车就不怕抢不到了！', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl:
              'https://agent-share.oss-accelerate.aliyuncs.com/resource-tc/4ggqjw94bkh/1665295741_lijiaqi.jpg', // 分享图标
            success: function () {
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: '李佳琦今日提前加购品，提前加车就不怕抢不到了！', // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl:
              'https://agent-share.oss-accelerate.aliyuncs.com/resource-tc/4ggqjw94bkh/1665295741_lijiaqi.jpg', // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });
      }
    } catch {}
  };
  //博主自定义合集
  //获取分类列表
  bloggerCategoryList: any = [];
  bloggerCategoryListLoading = false;
  bloggerCategoryId = 'all';
  postBloggerCategoryList = async () => {
    if (this.bloggerCategoryListLoading) return;
    this.bloggerCategoryListLoading = true;
    const search = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(
      `/d11admin/goods/live/categoryByGhId?ghId=${search.get('gh_id')}`,
      {
        method: 'GET',
        data: {},
      },
    );
    if (err) {
      if (`${err}` != 'Cancel') {
        this.bloggerCategoryListLoading = false;
      }
      return;
    }
    this.bloggerCategoryListLoading = false;
    this.bloggerCategoryList = data.data;
  };
  //获取数据
  //搜索关键词
  searchInputTextBloggerChange = async (e: any) => {
    const text = trim(e.target.value);
    this.bloggerKeywords = text;
    if (!text || text.length === 0) {
      this.bloggerKeywords = '';
    }
  };
  //查询关联商品列表
  bloggerKeywords = '';
  bloggerOldKeywords = '';
  bloggerSearchFlag = false;
  bloggerProductList: any = [];
  bloggerProductListLoading = false;
  bloggerProductTotal = 0;
  postBloggerProductList = async (flag = false) => {
    if (this.bloggerProductListLoading) return;
    const search = new URLSearchParams(window.location.search);
    let baseUrl = flag
      ? `/d11admin/goods/live/search?ghId=${search.get('gh_id')}`
      : `/d11admin/goods/live/queryByCategory?ghId=${search.get('gh_id')}`;
    if (this.bloggerCategoryId == 'all' || flag) {
    } else {
      baseUrl = `${baseUrl}&categoryId=${this.bloggerCategoryId}`;
    }
    if (flag) {
      if (this.bloggerKeywords && this.bloggerKeywords.length > 0) {
        baseUrl = `${baseUrl}&text=${this.bloggerKeywords}`;
        UM({
          page: '首页',
          label: '博主自定义合集',
          event: '博主自定义合集',
          value: this.bloggerKeywords,
        });
      } else {
        Toast.show({ content: '请输入搜索商品名称！' });
        return false;
      }
    }
    this.bloggerProductListLoading = true;
    this.bloggerProductTotal = 0;
    const { data, err }: any = await request(baseUrl, {
      method: 'GET',
      data: {},
    });
    if (err) {
      if (`${err}` != 'Cancel') {
        this.bloggerProductListLoading = false;
      }
      return;
    }
    const list = data.data || [];
    this.bloggerProductListLoading = false;
    if (flag && list.length == 0) {
      Toast.show({ content: '不好意思亲，没有搜到呢，要不换个词再试一下！' });
      return false;
    } else if (flag) {
      this.bloggerOldKeywords = this.bloggerKeywords;
      this.bloggerSearchFlag = true;
    }
    this.bloggerProductTotal = list.length;
    this.bloggerProductList = list;
  };
  //跳转处理
  copyText = '';
  hanleJump = (data: any) => {
    Toast.clear();
    if (isWeiBo()) {
      jumpHandle(data.urlScheme, data.link);
    } else if (isWeiXinAndQQ()) {
      // const handleCopyClipboard = (content: any) => {
      //   const inputDom = document.createElement('input');
      //   inputDom.setAttribute('value', content);
      //   document.body.appendChild(inputDom);
      //   inputDom.select();
      //   document.execCommand('copy');
      //   document.body.removeChild(inputDom);
      // }
      // handleCopyClipboard(data.taoToken);
      this.copyText = data.taoToken;
      Toast.show({
        content: '亲，口令复制成功啦，快打开淘宝抢购吧！',
        duration: 1500,
      });
    } else {
      // window.location.href = data.link;
      window.open(data.link);
    }
  };
  hanleJumpBlogger = (link: any) => {
    const urlScheme = link.replace('https', 'taobao');
    console.log(urlScheme);
    if (isWeiBo()) {
      jumpHandle(urlScheme, link);
    } else {
      window.location.href = link;
    }
  };
  //接口转链
  TransformLinkLoading = false;
  postTransformLink = async (params: any) => {
    Toast.show({
      icon: 'loading',
      maskClickable: false,
      duration: 0,
    });
    if (this.TransformLinkLoading) return;
    this.TransformLinkLoading = true;
    const { data, err }: any = await request(`/d11admin/goods/live/to/link`, {
      method: 'POST',
      data: params,
    });
    this.TransformLinkLoading = false;
    Toast.clear();
    if (err) {
      Toast.show({ content: `${err}` });
      return false;
    }
    if (data.code == '00000') {
      if (isWeiBo()) {
        jumpHandle(data.data.urlScheme, data.data.link);
      } else if (isWeiXinAndQQ()) {
        Toast.clear();
        if (document.execCommand('copy')) {
          const handleCopyClipboard = (content: any) => {
            const inputDom = document.createElement('input');
            inputDom.setAttribute('value', content);
            document.body.appendChild(inputDom);
            inputDom.select();
            document.execCommand('copy');
            document.body.removeChild(inputDom);
          };
          handleCopyClipboard(data.data.taoToken);
          Toast.show({ content: '亲，口令复制成功啦，快打开淘宝抢购吧！' });
        } else {
          MaskPopup.showCopay(`复制淘口令，打开淘宝购物`, data.data.taoToken);
        }
      } else {
        window.location.href = data.data.link;
      }
    }
  };
  //获取博主信息
  bloggerNickName = '博主';
  getHomeConfig = async () => {
    const { data, err }: any = await request(
      `/home/config`,
      {
        method: 'GET',
        data: {},
      },
      2,
    );
    if (err) {
      return;
    }
    this.bloggerNickName = data.data.bloggerNickName;
  };
  //新的直播主题页
  //搜索关键词
  searchKeywords = '';
  scene = 'lijiaqi';
  todayCategoryId = '';
  searchCategoryList: any = [];
  searchInputChange = async (e: any) => {
    const text = trim(e.target.value);
    this.searchKeywords = text;
    if (!text || text.length === 0) {
      this.searchKeywords = '';
    }
  };
  hasThemeConfig = false;
  switchFlag = false;
  baseCategoryList: any = [];
  initBaseCategoryList = () => {
    // const search = new URLSearchParams(window.location.search);
    // if (search.get('version') == 'linyilun') {
    //   this.baseCategoryList = [
    //     {
    //       name: '李佳琦直播间',
    //       id: 'lijiaqi',
    //     },
    //     {
    //       name: '所有女生直播间',
    //       id: 'girls',
    //     },
    //     {
    //       name: '林依轮直播间',
    //       id: 'linyilun',
    //     },
    //     {
    //       name: '查询直播价',
    //       id: 'live',
    //     },
    //   ];
    // } else {
    //   this.baseCategoryList = [
    //     {
    //       name: '李佳琦直播间',
    //       id: 'lijiaqi',
    //     },
    //     {
    //       name: '3月5日生活节',
    //       id: 'girls',
    //     },
    //     {
    //       name: '3月6日母婴节',
    //       id: 'girls_wardrobe',
    //     },
    //     {
    //       name: '查询直播价',
    //       id: 'live',
    //     },
    //   ];
    // }
    // this.topCategoryList = [...this.baseCategoryList];
  };
  topCategoryList: any = [];
  liveBannerVisible = false;
  liveBannerList: any = [];
  getLiveThemeConfig = async () => {
    const { data, err }: any = await request(
      `/live-theme/config`,
      {
        method: 'GET',
        data: {},
      },
      3,
    );
    if (data) {
      this.hasThemeConfig = true;
      if (data?.data?.tab) {
        data.data.tab.map((item: any) => {
          if (item.show === 1) {
            this.baseCategoryList.push({
              id: item.scene,
              name: item.name,
            });
            // if (item.scene === 'girls_wardrobe') {
            //   this.baseCategoryList.push({
            //     id: 'zhibojingxuan',
            //     name: '直播精选',
            //   });
            // }
          }
        });
        this.baseCategoryList.push({
          name: '查询直播价',
          id: 'live',
        });
        this.topCategoryList = [...this.baseCategoryList];
      }
      if (data?.data?.promotion?.switch == 1) {
        this.switchFlag = true;
        this.scene = 'promotion';
        this.topCategoryList = [
          {
            id: 'promotion',
            name: data?.data?.promotion?.name || '直播大促',
          },
          ...this.baseCategoryList,
        ];
      }
    }
  };
  getLiveBannerConfig = async () => {
    const { data, err }: any = await request(
      `/live-goods/banner`,
      {
        method: 'GET',
        data: {},
      },
      3,
    );
    if (err || !data) {
      this.liveBannerVisible = false;
      this.liveBannerList = [];
      return;
    }
    this.liveBannerVisible = !!data?.data?.show_banner;
    this.liveBannerList = this.liveBannerVisible
      ? (data?.data?.banner || []).map((item: any) => ({
          name: item.name,
          url: item.url,
        }))
      : [];
  };
  //获取商品列表
  liveLoading = false;
  firstLoading = false;
  liveList: any = [];
  pageScrollY = 0;
  liveScrollFlag = true;
  liveHasMore = true;
  liveFlatFlag = false;
  livePage = 1;
  liveSearchFlag = false;
  requestFirst = true;
  liveGoodsSource: any = [];
  liveGoodsSourceScene = '';
  getLiveGoodsUrl = (scene: string, platform: string) =>
    scene == 'promotion'
      ? `/live-goods/today-list?scene=lijiaqi&platform=${platform}&is_promotion=1`
      : `/live-goods/today-list?scene=${encodeURIComponent(scene)}&platform=${platform}`;
  setLiveGoodsList = (scene: string, list: any[]) => {
    // Keep the complete grouped source separate from search results.
    this.liveGoodsSourceScene = scene;
    this.liveGoodsSource = list;
    this.liveList = list;
    this.liveFlatFlag = false;
    this.searchCategoryList = list.map((item: any) => ({
      category_id: item.category_id.toString(),
      category_name: item.category_name,
    }));
    this.todayCategoryId = this.searchCategoryList[0]?.category_id || '';
  };
  getLiveList = async () => {
    const scene = this.scene;
    if (this.hasThemeConfig === false) {
      await this.getLiveThemeConfig();
      if (!this.requestFirst) {
        this.scene = scene;
      }
    }
    if (this.liveLoading) return;
    if (!this.liveHasMore) return;
    this.liveFlatFlag = this.scene == 'live';
    const platform = isWeiXin() ? 'shequn' : 'pc';
    let linkUrl =
      this.scene == 'live'
        ? `/live-goods/check-price?scene=${this.scene}&page_size=50&page=${this.livePage}&platform=${platform}`
        : this.getLiveGoodsUrl(this.scene, platform);
    if (this.scene == 'live' && this.liveSearchFlag && this.searchKeywords) {
      linkUrl = linkUrl + `&keyword=${this.searchKeywords}`;
    }
    if (isWeiXinAndQQ()) {
      linkUrl = linkUrl + `&platform=shequn`;
    }
    this.liveLoading = true;
    this.firstLoading = true;
    const { data, err }: any = await request(
      linkUrl,
      {
        method: 'GET',
        data: {},
        ...(this.scene != 'live' ? { excludeQueryParams: ['keyword'] } : {}),
      },
      3,
    );
    if (err) {
      return;
    }
    this.liveLoading = false;
    if (this.requestFirst && this.scene == 'promotion' && !data.data) {
      this.scene = 'lijiaqi';
      this.getLiveList();
      return;
    } else if (this.requestFirst && this.scene == 'lijiaqi' && !data.data) {
      this.scene = 'girls';
      this.getLiveList();
      return;
    } else if (this.scene == 'girls' && !data.data && this.requestFirst) {
      this.scene = this.baseCategoryList[2].id;
      this.requestFirst = false;
      this.getLiveList();
    } else {
      this.requestFirst = false;
    }
    if (this.scene != 'live') {
      this.setLiveGoodsList(this.scene, data.data || []);
    } else {
      let list = data.data.list || [];
      this.liveHasMore = data.data.hasMore;
      this.liveList = [...this.liveList, ...list];
      if (this.liveSearchFlag) {
        this.searchCategoryList = [
          {
            category_id: 'all',
            category_name: '全部',
          },
          {
            category_id: 'back',
            category_name: '返回列表',
          },
        ];
        this.todayCategoryId = 'all';
      }
      this.livePage = this.livePage + 1;
    }
  };
  //查询直播价
  liveCopyText = '';
  hanleJumpLive = (data: any) => {
    const url_scheme =
      this.scene == 'live' ? data.link_scheme : data.url_scheme;
    const link = this.scene == 'live' ? data.link : data.url;
    const tao_token = this.scene == 'live' ? data.tao_token : data.taotoken;
    Toast.clear();
    if (!String(tao_token || '').trim()) {
      // 接口在无口令时通过既有链接字段返回原始商品链接。
      this.liveCopyText = '';
      if (link) {
        window.open(link);
      } else {
        Toast.show({ content: '商品链接暂不可用' });
      }
      return;
    }
    if (isWeiBo()) {
      jumpHandle(url_scheme, link);
    } else if (isWeiXinAndQQ()) {
      this.liveCopyText = tao_token;
      Toast.show({
        content: '亲，口令复制成功啦，快打开淘宝抢购吧！',
        duration: 1500,
      });
    } else {
      // window.location.href = link;
      window.open(link);
    }
  };
  //获取H5列表  /api/repost/get-repost
  repostRenderList: any = [];
  repostRenderFromTab: any = '';
  getRepostList = async () => {
    document.title = '图文合集';
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('groupkey');
    if (!key) return;
    let localData: any = localStorage.getItem(key);
    if (localData) {
      localStorage.removeItem(key);
      localData = JSON.parse(localData);
      this.repostRenderList = localData.list;
      console.log(localData, '---');
      setTimeout(() => {
        window.scrollTo(localData.scrollY || 0);
      }, 10);
      return;
    }
    const { data, err }: any = await request(
      `/api/repost/render?key=${key}`,
      {
        method: 'GET',
        data: {},
      },
      4,
    );
    this.repostRenderList = data.data.list || [];
    this.repostRenderFromTab = data.data.from_tab || '';
  };

  //新的获取H5列表
  newRepostRenderList: any = [];
  newRepostRenderFromTab: any = '';
  getNewRepostList = async () => {
    document.title = '图文合集';
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('groupkey');
    if (!key) return;
    let localData: any = localStorage.getItem(key);
    if (localData) {
      localStorage.removeItem(key);
      localData = JSON.parse(localData);
      this.newRepostRenderList = localData.list;
      this.newRepostRenderFromTab = localData.tab;
      console.log(localData, '---');
      setTimeout(() => {
        window.scrollTo(localData.scrollY || 0);
      }, 10);
      return;
    }
    const { data, err }: any = await request(
      `/api/repost/h5-render?key=${key}`,
      {
        method: 'GET',
        data: {},
      },
      4,
    );
    this.newRepostRenderList = data.data.list || [];
    this.newRepostRenderFromTab = data.data.from_tab || '';
  };

  // 复制
  getRepostListCopy = async () => {
    document.title = '图文合集';
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('groupkey');
    if (!key) return;
    let localData: any = localStorage.getItem(key);
    if (localData) {
      localStorage.removeItem(key);
      localData = JSON.parse(localData);
      this.repostRenderList = localData.list;
      console.log(localData, '---');
      setTimeout(() => {
        window.scrollTo(localData.scrollY || 0);
      }, 10);
      return;
    }

    const jsonp = document.createElement('script');
    jsonp.type = 'text/javascript';

    jsonp.src = `https://cdn.mlj122.com/community-collect/${key}.json`;
    document.head.appendChild(jsonp);

    // window.onload = () => {
    //   console.log(window.groupData);

    //   this.repostRenderList = window.groupData.list || [];
    //   this.repostRenderFromTab = window.groupData.from_tab || '';
    // };
    jsonp.onload = () => {
      console.log(window.groupData);
      this.repostRenderList = window.groupData.list || [];
      this.repostRenderFromTab = window.groupData.from_tab || '';
    };
  };
  //保存页面位置
  savePosition() {
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('groupkey');
    if (key) {
      localStorage.setItem(
        key,
        JSON.stringify({
          list: this.repostRenderList,
          scrollY: window.scrollY,
        }),
      );
    }
    console.log(window.scrollY);
  }

  //保存页面位置
  newSavePosition() {
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('groupkey');
    if (key) {
      localStorage.setItem(
        key,
        JSON.stringify({
          list: this.newRepostRenderList,
          scrollY: window.scrollY,
          tab: this.newRepostRenderFromTab,
        }),
      );
    }
    console.log(window.scrollY);
  }

  searchList: any = [];
  searchLoading = false;
  searchCategoryListNew: any = [];
  getSearchList = async () => {
    if (this.scene == 'live') {
      return this.getSearchListFromApi();
    }
    if (this.searchLoading) return;
    const scene = this.scene;
    this.searchLoading = true;
    this.firstLoading = true;
    try {
      if (this.liveGoodsSourceScene != scene) {
        if (!this.hasThemeConfig) {
          await this.getLiveThemeConfig();
          this.scene = scene;
        }
        const platform = isWeiXin() || isWeiXinAndQQ() ? 'shequn' : 'pc';
        const { data, err }: any = await request(
          this.getLiveGoodsUrl(scene, platform),
          { method: 'GET', data: {}, excludeQueryParams: ['keyword'] },
          3,
        );
        if (err || !data) return;
        this.setLiveGoodsList(scene, data.data || []);
      }
      const keyword = trim(this.searchKeywords || '').toLowerCase();
      const list = this.liveGoodsSource.reduce(
        (products: any[], group: any) => [...products, ...(group.list || [])],
        [],
      );
      this.showSearchResults(list.filter((item: any) =>
        String(item.title ?? '').toLowerCase().includes(keyword) ||
        String(item.item_id ?? '').includes(keyword),
      ));
    } finally {
      this.searchLoading = false;
    }
  };
  // Keep the original remote search available; live price search still uses it.
  getSearchListFromApi = async () => {
    if (this.searchLoading) return;
    const platform = isWeiXin() ? 'shequn' : 'pc';

    const linkUrl = `/live-goods/query?platform=${platform}`;
    this.searchLoading = true;
    this.firstLoading = true;
    try {
      const { data, err }: any = await request(
        linkUrl,
        { method: 'GET', data: {} },
        3,
      );
      if (err || !data) return;
      const list = (data.data || []).reduce(
        (products: any[], group: any) => [...products, ...(group.list || [])],
        [],
      );
      this.showSearchResults(list);
    } finally {
      this.searchLoading = false;
    }
  };
  showSearchResults = (list: any[]) => {
    this.searchList = list;
    this.searchCategoryListNew = [
      {
        category_id: 'all',
        category_name: '全部',
      },
      {
        category_id: 'back',
        category_name: '返回列表',
      },
    ];
    this.todayCategoryId = 'all';
  };
}
export default new store();
